import type { FormDefData } from '../../Utils/types';
import { STRING, UI_TYPE_BINARY } from './FormTypes';

const formDef: FormDefData = {
  formId: 'Embalming',
  behaviors: {
    lockWhenFinalized: true,
    saveOnComplete: true,
    clearOnIncomplete: true,
    clearOnNotApplicable: true,
  },
  sections: [
    {
      id: 1,
      title: '',
      fields: [
        {
          id: 1,
          title: 'Pre Screen Complete',
          type: STRING,
          uiType: UI_TYPE_BINARY,
          responseOptions: ['Yes', 'No'],
          mandatory: true,
          tags: [],
        },
      ],
    },
  ],
};

export default formDef;
